'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bookingMetaDataRequested = bookingMetaDataRequested;
exports.bookingMetaDataReceived = bookingMetaDataReceived;
exports.bookingMetaDataRequestFailed = bookingMetaDataRequestFailed;
var BOOKING_META_DATA_REQUESTED = exports.BOOKING_META_DATA_REQUESTED = 'BOOKING_META_DATA_REQUESTED';

function bookingMetaDataRequested() {
    return {
        type: BOOKING_META_DATA_REQUESTED
    };
}

var BOOKING_META_DATA_RECEIVED = exports.BOOKING_META_DATA_RECEIVED = 'BOOKING_META_DATA_RECEIVED';

function bookingMetaDataReceived(bookingMetaData) {
    return {
        type: BOOKING_META_DATA_RECEIVED,
        bookingMetaData: bookingMetaData
    };
}

var BOOKING_META_DATA_REQUEST_FAILED = exports.BOOKING_META_DATA_REQUEST_FAILED = 'BOOKING_META_DATA_REQUEST_FAILED';

function bookingMetaDataRequestFailed(error) {
    return {
        type: BOOKING_META_DATA_REQUEST_FAILED,
        error: error
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/bookingMetaDataActions.js
// module id = 200
// module chunks = 0